import React from "react";
import {
  EdgeSectionWrapper,
  EdgeContainer,
  EdgeCard,
} from "./EdgeToolStyled";

const edgeTools = [
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772069105/arduino_gcpeaf.png",
    title: "Arduino",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772070296/raspberry_pi_tshzdk.png",
    title: "Raspberry Pi",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772071285/kicad_lb8ztd.png",
    title: "KiCad",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772072100/FreeCAD-logo.svg_-808614354_jsol0l.png",
    title: "Freecad",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/9/9a/STM32_logo.svg",
    title: "STM32",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/6/62/PlatformIO_logo.svg",
    title: "PlatformIO",
  },
];

export default function EdgeTechSection() {
  return (
    <EdgeSectionWrapper>
      <EdgeContainer>
        {edgeTools.map((tool, idx) => (
          <EdgeCard key={idx}>
            <img src={tool.src} alt={tool.title} loading="lazy" />
            <h5>{tool.title}</h5>
          </EdgeCard>
        ))}
      </EdgeContainer>
    </EdgeSectionWrapper>
  );
}